import { useEffect, useState } from "react";
import { serialize } from "../components/dashboard/richTextEditor/utils/serializer";

export const useSerializeMessage = (message) => {
  const [tempMessage, setTempMessage] = useState("");

  useEffect(() => {
    if (message !== "") {
      const temp = serialize({ children: message });
      setTempMessage(temp);
    }
  }, [message]);

  useEffect(() => {
    if (message !== "") {
      const temp = serialize({ children: message });
      setTempMessage(temp);
    }
  }, []);

  return tempMessage;
};
